import Button from '@mui/material/Button';
import styled from 'styled-components';

export const StyledButton = styled(Button)`
    background-color: #465eb6 !important;
    color: #fff !important;
    font-family: 'Roboto', sans-serif !important;
    font-size: 14px !important;
    font-weight: 500 !important;
    text-transform: none !important;
    border-color: #0037ff;
    
    :hover {
        background-color: #2e4ec3 !important;
        opacity: 0.8;
    }

    :disabled {
        background-color: #ccc !important;
        opacity: 0.5;
    }

    transition: background-color 0.2s;
`;
